const preventForwardProps = (prevented) => {
  return (prop) => {
    return !prevented.includes(prop);
  };
};
const preventForwardPropsConfig = (prevented) => ({
  shouldForwardProp: preventForwardProps(prevented)
});

export { preventForwardPropsConfig };
//# sourceMappingURL=preventForwardProps.js.map
